<template>
  <div class="question">
    <div class="big-wrapper js-accordion" v-for="(data, key) in only_beta" :key="key"><a class="big-link js-accordion--trigger" :class="{ 'active': isOpened[key] }" @click="accordionToggle(key)">Q. {{ data.title.rendered}}</a>
      <transition name="js-accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div class="js-accordion--target" :class="{ '_state-open': isOpened[key] }" v-if="isOpened[key]">
          <div class="acordion js-accordion--body">
            <div class="answer white-space-pre-wrap" v-html="data.content.rendered"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'usage_faq',
    data() {
      return {
        qaList: this.questionAnswers,
        isOpened: {
          '0': false,
          '1': false,
          '2': false,
          '3': false,
          '4': false,
          '5': false,
          '6': false,
          '7': false,
          '8': false,
          '9': false,
          '10': false,
          '11': false,
          '12': false,
          '13': false,
          '14': false,
          '15': false,
          '16': false,
          '17': false,
          '18': false,
          '19': false,
          '20': false,
        }
      }
    },
    methods: {
      ...mapActions('faq', ['getQuestionAnswers', 'getCategories']),
      // eslint-disable-next-line
      accordionToggle: function (val) {
        this.isOpened[val] = !this.isOpened[val]
      },
      // eslint-disable-next-line
      beforeEnter: function (el) {
        // eslint-disable-next-line
        el.style.height = '0'
      },
      // eslint-disable-next-line
      enter: function (el) {
        // eslint-disable-next-line
        el.style.height = el.scrollHeight + 'px'
      },
      // eslint-disable-next-line
      beforeLeave: function (el) {
        // eslint-disable-next-line
        el.style.height = el.scrollHeight + 'px'
      },
      // eslint-disable-next-line
      leave: function (el) {
        // eslint-disable-next-line
        el.style.height = '0'
      },
    },
    computed: {
      ...mapState('faq', ['questionAnswerLoading', 'currentId']),
      ...mapGetters('faq', ['questionAnswers', 'categories', 'only_beta']),
      count() {
        return this.only_beta.length
      }
    },
    created() {
      if (this.questionAnswers.length === 0) {
        this.getCategories()
        this.getQuestionAnswers()
      } else {
        this.$set(this, 'qaList', this.questionAnswers)
      }
    },
    mounted() {
    },
    watch: {
      questionAnswers(data) {
        this.$set(this, 'qaList', data)
      }
    },
  }
</script>
<style lang="scss">
.js-accordion{
  &--trigger{
    position: relative;
    transition: all 0.2s ease-in;
  }
  &--target{
    overflow: hidden;
    transition: height 0.4s ease-in-out;
  }
  &-enter-active{
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__opend;
  }
  &-leave-active{
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__closed;
  }
}
@keyframes js-accordion--anime__opend {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
   }
}
@keyframes js-accordion--anime__closed {
  0% {
   opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
